import {Component} from "@angular/core";
import {Router} from "@angular/router-deprecated";

@Component({
  selector: "router-router",
  template: `
  <usecase-container title="Router" src="router/router">
    <usecase-content>
      <button (click)="goToRouter()">Go to Router</button>
    </usecase-content>
  </usecase-container>
  `,
})
export class RouterComponent {
  constructor(private router: Router) {
  }

  goToRouter() {
    this.router.navigateByUrl("/router");
  }
}



/** WEBPACK FOOTER **
 ** ./script/router/router/component.ts
 **/